module.exports = __webpack_public_path__ + "static/img/tit1.f75b302a.png";